import { DBMaterialType } from "../database_types";
import { Table } from "react-bootstrap";

export function DatabaseView(props: { materials: DBMaterialType[], edges: DBMaterialType[] }) {
    return <>
        <h1>Dostępne obrzeża</h1>
        <Table striped bordered hover>
            <thead>
                <tr>
                    <th>Product ID</th>
                    <th>Nazwa Materiału</th>
                    <th>Opis</th>
                    <th>Grubość</th>
                    <th>Usłojenie</th>
                </tr>
            </thead>
            <tbody>
                {props.materials.map((mat) => <tr>
                    <td>{mat.code}</td>
                    <td>{mat.name}</td>
                    <td>{mat.description}</td>
                    <td>{mat.thickness}</td>
                    <td>{mat.graining}</td>
                </tr>)}
            </tbody>
        </Table>

        <h1>Dostępne materiały (płyty)</h1>
        <Table striped bordered hover>
            <thead>
                <tr>
                    <th>Product ID</th>
                    <th>Nazwa Materiału</th>
                    <th>Opis</th>
                    <th>Grubość</th>
                    <th>Usłojenie</th>
                </tr>
            </thead>
            <tbody>
                {props.edges.map((mat) => <tr>
                    <td>{mat.code}</td>
                    <td>{mat.name}</td>
                    <td>{mat.description}</td>
                    <td>{mat.thickness}</td>
                    <td>{mat.graining}</td>
                </tr>)}
            </tbody>
        </Table>
    </>;
}